var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"preview-mode-close-button",on:{"click":_vm.togglePreviewMode}},[_vm._v(" Close Preview ")])
}
var staticRenderFns = []

export { render, staticRenderFns }